import { ca } from '@cian/analytics';

import { MORTGAGE } from '../../constants/navbar/linkNames';
import { rubricToAnalyticsCategory } from '../../hooks/useDropdownLinks/useBottomLinks/utils';
import { getAnaliticName } from '../../hooks/useDropdownLinks/utils/getAnaliticName';
import { ERubric } from '../../types/rubricsLinks';

const MORTGAGE_TRAP_PAGE_EXTRA = {
  trap_type: 'mortgage_header_tab',
  bannerName: MORTGAGE,
  trapid: MORTGAGE,
} as const;

function trackMortgageTrapEvent(action: 'click_sopr' | 'show_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action,
    label: 'mortgage_tab',
    page: {
      extra: MORTGAGE_TRAP_PAGE_EXTRA,
    },
  });
}

function closureTrackNavBarMortgageShow() {
  let wasEventSent = false;

  return () => {
    if (wasEventSent) {
      return;
    }

    wasEventSent = true;
    trackMortgageTrapEvent('show_sopr');
  };
}

/** Показ пункта «Ипотека» в главном меню; не более одного события за жизненный цикл страницы */
export const trackNavBarMortgageShow = closureTrackNavBarMortgageShow();

export function trackNavBarClick(rubric: ERubric, url?: string) {
  if (rubric === ERubric.Mortgage) {
    trackMortgageTrapEvent('click_sopr');

    return;
  }

  const category = rubricToAnalyticsCategory(rubric);
  const label = getAnaliticName(rubric, url);

  ca('eventSite', {
    name: 'oldevent',
    category,
    action: 'top_menu',
    label,
  });
}
